/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Result from '../result';
import URI from 'urijs';

var Responds = function Responds(self) {
  /*
   * @namespace Model
   * @mixin
   *
   */
  return {
    respond: function respond(value, options) {
      var result = new Result({
        value: value
      }); // set the source if it's defined

      if (self.has('source') || __guard__(self.collection != null ? self.collection.poll : undefined, function (x) {
        return x.has('source');
      })) {
        result.set({
          source: self.get('source') || __guard__(self.collection != null ? self.collection.poll : undefined, function (x1) {
            return x1.get('source');
          })
        });
      }

      var responseUrl = URI(self.responseUrl());

      if (options != null ? options.include_confirmation_message : undefined) {
        responseUrl.addQuery('include_confirmation_message', '1');
      }

      return result.save(null, {
        url: responseUrl.toString()
      });
    }
  };
};

export default Responds;

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}